import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MemberInvitationResendInput, MemberInvitationResendPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { useLocale } from 'next-intl';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = MemberInvitationResendInput;
type TData = MemberInvitationResendPayload;

export const useMemberInviteResend = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();
  useLocale;

  const graphql = gql`
    mutation memberInvitationResend($input: MemberInvitationResendInput!) {
      memberInvitationResend(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
